import { render, staticRenderFns } from "./SurveyQualificationLanguage.vue?vue&type=template&id=5207584f&scoped=true&"
import script from "./SurveyQualificationLanguage.vue?vue&type=script&lang=js&"
export * from "./SurveyQualificationLanguage.vue?vue&type=script&lang=js&"
import style0 from "./SurveyQualificationLanguage.vue?vue&type=style&index=0&id=5207584f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5207584f",
  null
  
)

export default component.exports